/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextBookCountItemVo model module.
   * @module textbook/model/TextBookCountItemVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookCountItemVo</code>.
   * @alias module:textbook/model/TextBookCountItemVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>TextBookCountItemVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookCountItemVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookCountItemVo} The populated <code>TextBookCountItemVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'auditStatus')) {
        obj['auditStatus'] = ApiClient.convertToType(data['auditStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'onlineStatus')) {
        obj['onlineStatus'] = ApiClient.convertToType(data['onlineStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'label')) {
        obj['label'] = ApiClient.convertToType(data['label'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'count')) {
        obj['count'] = ApiClient.convertToType(data['count'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 审核状态 null全部， 0待上传1上传完毕待审核 2审核通过 -1撤回 -2审核不通过
   * @member {Integer} auditStatus
   */
  exports.prototype['auditStatus'] = undefined;
  /**
   * 当前上线状态 null全部，1上线 0未上线
   * @member {Integer} onlineStatus
   */
  exports.prototype['onlineStatus'] = undefined;
  /**
   * 状态名称，当auditStatus为2审核通过时，通过auditStatus和onlineStatus的label名字拼接，否则为auditStatus的label名字
   * @member {String} label
   */
  exports.prototype['label'] = undefined;
  /**
   * 该审核状态的教材数量
   * @member {Integer} count
   */
  exports.prototype['count'] = undefined;



  export default exports;
;


